import { Autocomplete, TextField, type SxProps, type Theme } from '@mui/material';

export interface ReadOnlySelectAutocompleteProps<T> {
	options: T[];
	value: T | null;
	onChange: (value: T | null) => void;
	getOptionLabel: (option: T) => string;
	isOptionEqualToValue?: (option: T, value: T) => boolean;
	label?: string;
	placeholder?: string;
	error?: boolean;
	disabled?: boolean;
	fullWidth?: boolean;
	className?: string;
	noOptionsText?: string;
	textFieldSx?: SxProps<Theme>;
}

/** Dropdown-style autocomplete: opens on focus, not typable, clearable via built-in X. */
export function ReadOnlySelectAutocomplete<T>({
	options,
	value,
	onChange,
	getOptionLabel,
	isOptionEqualToValue,
	label,
	placeholder,
	error,
	disabled,
	fullWidth = true,
	className,
	noOptionsText = 'No options',
	textFieldSx,
}: ReadOnlySelectAutocompleteProps<T>) {
	return (
		<Autocomplete
			options={options}
			value={value}
			onChange={(_, newValue) => onChange(newValue)}
			getOptionLabel={getOptionLabel}
			isOptionEqualToValue={isOptionEqualToValue}
			openOnFocus
			clearOnBlur={false}
			handleHomeEndKeys
			disabled={disabled}
			noOptionsText={noOptionsText}
			renderInput={(params) => (
				<TextField
					{...params}
					label={label}
					placeholder={!value ? placeholder : undefined}
					error={error}
					className={className}
					fullWidth={fullWidth}
					sx={textFieldSx}
					slotProps={{
						htmlInput: {
							...params.inputProps,
							readOnly: true,
							inputMode: 'none',
						},
					}}
				/>
			)}
		/>
	);
}
